import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, IconButton, Toolbar, Typography } from "@mui/material";
import I18n from "i18n-js";
import { PERMISSIONS } from "../../app/constants";
import useAccess from "../profile/useAccess";
import SharingTools from "../sharings/SharingTools";
import { useSharingContext } from "./WaiverSharings";

export default function WaiverSharingDetail() {
  const { selectedSharing, editSharing, deleteSharing } = useSharingContext();
  const access = useAccess();

  if (!selectedSharing) {
    return null;
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          {I18n.t("Sharing.selectSharing")}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2 }}>
      {/* Toolbar with action buttons */}
      <Toolbar sx={{ px: 0, minHeight: "48px !important" }}>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          {selectedSharing.name}
        </Typography>
        {access.hasPermissions(PERMISSIONS.MANAGE_SHARINGS) && (
          <IconButton
            title={I18n.t("App.edit")}
            onClick={() => editSharing(selectedSharing)}
          >
            <EditIcon />
          </IconButton>
        )}
        {access.hasPermissions(PERMISSIONS.MANAGE_SHARINGS) && (
          <IconButton
            title={I18n.t("App.delete")}
            onClick={() => deleteSharing(selectedSharing)}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Toolbar>

      {/* SharingTools component */}
      <SharingTools sharing={selectedSharing as any} onClose={() => {}} />
    </Box>
  );
}
